import { baseApi } from './baseApi';

const brandingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBranding: builder.query({
      query: ({ host } = {}) => ({
        url: '/branding',
        method: 'GET',
        params: host ? { host } : undefined,
      }),
    }),
  }),
});

export default brandingApi;
